import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { ShimmerThumbnail } from 'react-shimmer-effects'
import { useErrorService } from '@abroad/components'
import API from '../../utils/API'
import { v4 as uuidv4 } from 'uuid'
import { QuestIntentionCard } from '.'

const QuestsIntention = ({ questId: questIdProp, count }) => {
  const { questId: questIdFromParams } = useParams()
  const questId = questIdProp || questIdFromParams
  const [isLoading, setIsLoading] = useState(true)
  const [intentions, setIntentions] = useState([])
  const Error = useErrorService()

  useEffect(() => {
    const getintentions = async () => {
      try {
        const { data } = await API.intention.getIntentions({
          archived: false,
          questId,
        })
        if (data.intentions.length < 2) {
          setIntentions([
            ...data.intentions,
            ...Array.from({ length: 2 - data.intentions.length }, (x, i) => ({
              _id: uuidv4(),
              isLocal: true,
              title:
                'Click here to create a new intention for generating additional insights',
              createdAt: new Date(),
            })),
          ])
        } else {
          setIntentions([
            ...data.intentions,
            ...Array.from({ length: 1 }, (x, i) => ({
              _id: uuidv4(),
              isLocal: true,
              title:
                'Click here to create a new intention for generating additional insights',
              createdAt: new Date(),
            })),
          ])
        }
        // data.intentions.length && setCount(data.intentions.length)
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        Error.showError(e)
      }
    }
    getintentions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questId])

  return (
    <>
      <div className='mt-32px'>
        {isLoading ? (
          <>
            <div className='mt-32px'>
              <div className='mt-30px responsive-entries-thumbnail'>
                <Row>
                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <ShimmerThumbnail rounded />
                  </Col>
                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <ShimmerThumbnail rounded />
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <ShimmerThumbnail rounded />
                  </Col>
                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <ShimmerThumbnail rounded />
                  </Col>
                </Row>
              </div>
            </div>{' '}
          </>
        ) : (
          <>
            <div>
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center justify-content-center'>
                      <div className='s14 me-2'>Clarify Your Intentions</div>
                      <div className='d-flex align-items-center justify-content-center custom-24px rounded-circle mt-1'>
                        <span className='s-small-description text-white'>
                          {count}
                        </span>
                      </div>
                    </div>
                    <div>
                      <Link
                        to={`/your-experiences/${questId}/all-intentions`}
                        className='s8 result-active-link assessment-result-link'>
                        View All
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12}>
                  <Row>
                    {(() => {
                      const realIntentions = [...intentions].filter(
                        (i) => !i.isLocal,
                      )
                      const sortedIntentions = realIntentions.sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
                      )

                      if (realIntentions.length === 0) {
                        // Show 2 add-new cards
                        return Array.from({ length: 2 }).map((_, idx) => (
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            key={`add-new-${idx}`}
                            className='my-3 px-3'>
                            <QuestIntentionCard
                              index={idx + 1}
                              intention={{
                                _id: `add-new-${idx}`,
                                isLocal: true,
                                title:
                                  'Click here to create a new intention for generating additional insights',
                                createdAt: new Date(),
                              }}
                              questId={questId}
                            />
                          </Col>
                        ))
                      }

                      if (realIntentions.length === 1) {
                        // Show 1 real + 1 add-new card
                        const first = sortedIntentions[0]
                        return (
                          <>
                            <Col
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              key={first._id}
                              className='my-3 px-3'>
                              <QuestIntentionCard
                                index={1}
                                intention={first}
                                questId={questId}
                              />
                            </Col>
                            <Col
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              key='add-new'
                              className='my-3 px-3'>
                              <QuestIntentionCard
                                index={2}
                                intention={{
                                  _id: 'add-new',
                                  isLocal: true,
                                  title:
                                    'Click here to create a new intention for generating additional insights',
                                  createdAt: new Date(),
                                }}
                                questId={questId}
                              />
                            </Col>
                          </>
                        )
                      }

                      // 2 or more real intentions → show latest 2
                      return sortedIntentions
                        .slice(0, 2)
                        .map((intention, index) => (
                          <Col
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            key={intention._id}
                            className='my-3 px-3'>
                            <QuestIntentionCard
                              index={index + 1}
                              intention={intention}
                              questId={questId}
                            />
                          </Col>
                        ))
                    })()}
                  </Row>
                </Col>
              </Row>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default QuestsIntention
